import { render, staticRenderFns } from "./RequestRecipients.vue?vue&type=template&id=a368e4aa"
import script from "./RequestRecipients.vue?vue&type=script&lang=js"
export * from "./RequestRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports